module.exports = __webpack_public_path__ + "img/05_speaker2.2edcc135.png";